import * as React from 'react';
import { Header } from './Header';
import SelectForm from './SelectForm';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from "redux";
import { setCouncils } from "src/actions";
import { connect } from "react-redux";

interface IProps extends RouteComponentProps {
  setCouncils: () => void;
}

class SelectionScreen extends React.PureComponent<IProps, {}> {
  public render() {
    this.props.setCouncils();
    return (
      <div className="h-screen flex flex-col">
        <Header />
        <section className="flex flex-row flex-1">
          {/* Form */}
          <div className="bg-white h-full w-full lg:w-1/2 flex items-center justify-center">
            <SelectForm history={this.props.history} />
          </div>
          {/* Map */}
          <div className="bg-grey h-full w-1/2 map hidden lg:block" />
        </section>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCouncils: () =>
    dispatch(setCouncils([]))
});

export default connect(
  null,
  mapDispatchToProps
)(SelectionScreen);


// WEBPACK FOOTER //
// ./src/components/SelectScreen.tsx